import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSy...",
  authDomain: "://firebaseapp.com",
  projectId: "shepherd-extension",
  storageBucket: "shepherd-extension.firebasestorage.app",
  messagingSenderId: "520511763342",
  appId: "1:520511763342:web:4b509e8281083a4d9b6adf",
  measurementId: "G-4ZN6G23LPC",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // Exporting the database instance
